import React from 'react';
import { useRouter } from 'next/router';

import useParams from 'legacy/common/hooks/useParams';
import {
  useGetAnalytics,
  useGetEvent,
  useGetEventSummary
} from 'legacy/events/hooks';

import FadeIn from 'legacy/common/components/transition/FadeIn';
import OverallNumbers from 'legacy/events/components/analytics/OverallNumbers';
import TrackingLinks from 'legacy/events/components/analytics/TrackingLinks';
import AnalyticsActions from 'legacy/events/components/analytics/AnalyticsActions';
import { isBounceWebview, postMessageToRN } from 'legacy/common/utils/webview';
import { WEBVIEW_CLOSE } from 'legacy/common/constants/webview';
import Redirect from 'legacy/components/util/Redirect/Redirect';

const AnalyticsPage = () => {
  const router = useRouter();

  const params = useParams<{
    slug: string;
    tierShareToken: string;
    invite: string;
  }>();
  const eventId = params.slug;

  const { data: event, isLoading: isEventLoading } = useGetEvent(eventId);

  const {
    data: analytics,
    isLoading: isLoadingAnalytics,
    error
  } = useGetAnalytics(eventId, {
    enabled: event?.isOrganizer
  });
  const { data: eventSummary } = useGetEventSummary(
    eventId,
    event?.isOrganizer
  );

  const payoutAmount = eventSummary?.totals?.payoutAmount || 0;
  const ticketsSold = eventSummary?.totals?.ticketsSold || 0;

  const onBack = () => {
    if (isBounceWebview(router.query)) {
      postMessageToRN(WEBVIEW_CLOSE);
    } else {
      router.back();
    }
  };

  // Make sure only organizers can access the page
  if (!isEventLoading && !event?.isOrganizer) {
    return <Redirect to="/404" />;
  }

  return (
    <>
      <div className="pb-24">
        <FadeIn>
          <OverallNumbers
            views={analytics?.views}
            sales={ticketsSold}
            revenue={payoutAmount}
            onBack={onBack}
            isLoading={isLoadingAnalytics}
            error={error}
          />

          <TrackingLinks trackingLinks={analytics?.trackingLinks} />
        </FadeIn>
      </div>
      <AnalyticsActions eventId={eventId} />
    </>
  );
};

export default AnalyticsPage;
